export default {
  aura: 'acquirer.aura',
  banco_panamericano: 'acquirer.banco_panamericano',
  bin: 'acquirer.bin',
  cetelem: 'acquirer.cetelem',
  cielo: 'acquirer.cielo',
  conductor: 'acquirer.conductor',
  credsystem: 'acquirer.credsystem',
  dacasa: 'acquirer.dacasa',
  dm_card: 'acquirer.dm_card',
  ebanx: 'acquirer.ebanx',
  elavon: 'acquirer.elavon',
  epay: 'acquirer.epay',
  getnet: 'acquirer.getnet',
  global_payments: 'acquirer.global_payments',
  havan: 'acquirer.havan',
  hugcard: 'acquirer.hugcard',
  kredilig: 'acquirer.kredilig',
  leadercard: 'acquirer.leadercard',
  pagarme: 'acquirer.pagarme',
  pagseguro: 'acquirer.pagseguro',
  redecard: 'acquirer.redecard',
  safrapay: 'acquirer.safrapay',
  senff: 'acquirer.senff',
  sodexo: 'acquirer.sodexo',
  sorocred: 'acquirer.sorocred',
  stone: 'acquirer.stone',
  ticket: 'acquirer.ticket',
  vr: 'acquirer.vr',
  others: 'acquirer.others',
  simulator: 'acquirer.simulator'
}
